import { Component, OnInit, Input, NgZone, Output, EventEmitter, HostListener } from '@angular/core';
import * as moment from 'moment';
import { DashboardService } from '../_services/dashboard.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ReportsFilter } from '../_model/reports-filter.model';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var $: any;


@Component({
  selector: 'app-reports-control-bar',
  templateUrl: './reports-control-bar.component.html',
  styleUrls: ['./reports-control-bar.component.scss']
})
export class ReportsControlBarComponent implements OnInit {
  filterStatus = false;
  searchInput;
  searchDropdown;
  dropdownItems;
  rangeDates;
  todayDate;
  grades;
  classes = [];
  filteredGrades;
  fiteredClasses;
  fiteredAttendance;
  allGrades;
  allGradesSelected = false;
  allClassesSelected =false;
  reportFilter: any = {};
  filterApplied = 'Grades | Classes Filter Applied';
  filterAttendanceApplied = 'Attendance Filter Applied'
  filteredAppliedFlag = false;
  filteredAttendanceAppliedFlag = false;
  allClassesIsChecked: boolean;
  selectedGrades = [];
  allGradesIsChecked: boolean;
  showedClasses = [];
  selectedClasses = [];
  dismissialStatueses = [];
  filterValues: ReportsFilter;
  selectedGradesCheckBoxes = [];
  selectedClassesCheckBoxes = [];
  @Input() controlType;
  @Input() hideFilter = false;
  @Input() hideFilterTag = false;
  @Input() listType;
  @Input() statusType;
  @Output() finishedLoading = new EventEmitter();
  @Output() stopLoading = new EventEmitter();
  @Output() exportExcel = new EventEmitter<string>();
  @Output() generateExcel = new EventEmitter<boolean>();

  timer = null;
  dropdownTimer = null;
  reportType = 'week';
  currentTab;
  initSub;
  hideDateRanges = false;
  hideDate = false;
  currLang;
  noClazzFlag: boolean = false;
  customOptions = {
    // loop: true,
    // rewind: true,
    items: 8,
    // mouseDrag: true,
    // touchDrag: true,
    // pullDrag: true,
    // autoWidth: true,
    navSpeed: 700,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    autoplaySpeed: 1500,
    animateIn: true,
    animateOut: true,
    dots: false,
    // dotsSpeed:700,
    slideBy: 'item',
    slideTransition: 'ease-out',

  };
  from_date;
  to_date;
  constructor(private dashboardService: DashboardService,
    private snackBar: SnackbarService,
    private _snackBar: MatSnackBar,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dataService: DataService, private router: Router, private _ngZone: NgZone) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.initSub = new Subscription();

    this.currentTab = this.router.url.split('/')[2];

  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.translate.onLangChange.subscribe(res => {
      this.filteredAppliedFlag = false;
      this.filteredAttendanceAppliedFlag = false;
    });
    // to fix date key doesn't exist in local storage on init which stops the real time in dashboard
    localStorage.setItem('date',  moment(new Date()).format('YYYY-MM-DD'));
    this.initFilter();
    this.initStatusFilter();
    let x = this.dashboardService.getInitFilter().subscribe((res: any) => {
      if (res) {
        this.initFilter();
      }
    })
    this.initSub.add(x);
    this.allClassesIsChecked = false;
    this.allGradesIsChecked = false;
    this.filterValues = new ReportsFilter();
    this.filterValues.grades = [];
    this.filterValues.classes = [];
    this.filterValues.attendance = [];

    this.dashboardService.getFilterStatus().subscribe((res: any) => {
      this.filterStatus = res;
    })

    this.dataService.getFilterFlag().subscribe((res => {
      if (res === 'close') {
        // this.allGradesIsChecked = false;
        // this.allClassesIsChecked = false;
        // this.roleFilter = [];
        // this.filterValues = new Filter();
        // this.filterValues.grades = [];
        // this.filterValues.classes = [];
        // this.filterValues.roles = [];
        // this.filterValues.routes = [];
        // this.filterValues.gates = [];
        // this.filterValues.registration = -1;
        // this.dataService.setRowsNumberShown(this.rowsNumberToBeShowed);
        // this.dataService.setSearchText(null);
      }
    }))

    this.dashboardService.getFilterValue().subscribe((res => {
      switch (true) {
        case res.grades != undefined && res.grades.length != 0 || res.classes != undefined && res.classes.length != 0:
          this.filteredAppliedFlag = true;
          break;
        case res.attendance != undefined && res.attendance.length != 0:
          this.filteredAttendanceAppliedFlag = true;
          break;
        default:
          this.filteredAppliedFlag = false;
          this.filteredAttendanceAppliedFlag = false;
      }
    }))

    this.dataService.getAllGrades().subscribe((res: any) => {
      this.grades = res;
      this.grades.map(grade => {
        this.classes.push(...grade.school_classes)
      })
      this.dashboardService.sentGrades(this.grades);
      this.dashboardService.sentClasses(this.classes);
    })
  }

  ngOnDestroy(): void {
    this.initSub.unsubscribe();
  }

  ngOnChanges(simpleChanges) {
    if (this.currentTab === 'attendance-reports' && simpleChanges.controlType.firstChange === false) {
      if (simpleChanges.controlType.previousValue !== simpleChanges.controlType.currentValue) {
        this.initFilter();
      }
    }

    if (this.currentTab === 'dismissal-reports' && simpleChanges.controlType.firstChange === false) {
      if (simpleChanges.controlType.previousValue !== simpleChanges.controlType.currentValue) {
        this.controlType == 'students-log' ? this.statusType = 'students-log' : '';
        this.initFilter();
        this.initStatusFilter();
      }
    }

    this.dashboardService.getFilterStatus().subscribe((res: any) => {
      this.filterStatus = res;
    })
  }

  initFilter() {
    let date = localStorage.getItem('date');

    this.rangeDates = [];
    this.reportFilter = new ReportsFilter();
    this.reportFilter.toDate = date ? date : moment(new Date()).format('YYYY-MM-DD');
    this.reportFilter.fromDate = date ? date : moment(new Date()).format('YYYY-MM-DD');
    this.rangeDates.push(date ? new Date(date) : new Date());
    this.rangeDates.push(date ? new Date(date) : new Date());

    let temp = this.dashboardService.getRangeDateValue()
    if (temp.length) {
      this.rangeDates = temp;
    }
    this.dashboardService.getRangeDate().subscribe(res => {
      if (res) {
        this.rangeDates = res;
      }

    })


    this.reportFilter.search = undefined;
    this.dataService.getAllGrades().subscribe((res: any) => {
      if (res.length != 0) {
        this.grades = res;
        this.allGradesSelected = true;
        this.allClassesSelected = true;
        // this.reportFilter.grade = this.grades[0];
        this.classes = [...this.grades[0].school_classes];
        // this.reportFilter.clazz = this.classes[0];
        this.searchInput = null;
        this.searchDropdown = null;
        this.dashboardService.setReportFilter(this.reportFilter);
        this.stopLoading.emit(true);
      }
      // this.grades = res;
      // this.reportFilter.grade = this.grades[0];
      // this.classes = [...this.grades[0].school_classes];
      // this.reportFilter.clazz = this.classes[0];
      // this.searchInput = null;
      // this.dashboardService.setReportFilter(this.reportFilter);
      // this.stopLoading.emit(true);
    })
  }

  setIconClass() {
    let iconClass = 'search-icon'
    iconClass = this.controlType === 'attendance-week' ? 'search-icon-week' :
      this.controlType === 'attendance-day' ? 'search-icon-day' :
        'search-icon'
    return iconClass;
  }

  setDate(event) {
    this.reportFilter.toDate = moment(event.target.value).format('YYYY-MM-DD');
    this.reportFilter.fromDate = moment(event.target.value).format('YYYY-MM-DD');
    // this.dashboardService.setToDate(moment(event.target.value).format('YYYY-MM-DD'));
    // this.dashboardService.setFromDate(moment(event.target.value).format('YYYY-MM-DD'));
    localStorage.setItem('date', this.reportFilter.toDate);
    this.dashboardService.setReportFilter(this.reportFilter);
  }

  setCustomDate(event, flag) {
    flag == 'from' ? this.reportFilter.fromDate = moment(event.target.value).format('YYYY-MM-DD') : this.reportFilter.toDate = moment(event.target.value).format('YYYY-MM-DD');
    this.dashboardService.setReportFilter(this.reportFilter);
  }
  setGrade(event) {
    this.classes = [];
    this.noClazzFlag = false;
    this.allClassesSelected = true;
    if (event.value == 'allGrades') {
      this.allGradesSelected = true;
      let tempFilter = this.reportFilter;
      delete tempFilter.grade;
      delete tempFilter.clazz;
      this.dashboardService.setReportFilter(tempFilter);
    }
    else {
      this.reportFilter.grade = event.value;
      this.allGradesSelected = false;
      if (event.value.school_classes.length == 0) {
        this.noClazzFlag = true;
      }
      else {
        this.classes = [...event.value.school_classes];
        // this.reportFilter.clazz = this.classes[0];
      }
      this.dashboardService.setReportFilter(this.reportFilter);
    }
  }

  setClass(event) {
    if (event.value == 'allClasses') {
      this.allClassesSelected = true;
      let tempFilter = this.reportFilter;
       delete tempFilter.clazz;
      this.dashboardService.setReportFilter(tempFilter);
    }
    else {
      this.reportFilter.clazz = event.value;
      this.allClassesSelected = false;
      this.dashboardService.setReportFilter(this.reportFilter);
    }
  }
  setStatus(event) {
    // this.reportFilter.dismissal ={};
    this.reportFilter.dismissalStatus = event.value.status;
    this.reportFilter.dismissalType = event.value.type;
    this.dashboardService.setReportFilter(this.reportFilter);
  }

  clearSearch() {
    this.searchInput = '';
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.reportFilter.search = this.searchInput;
      this.dashboardService.setReportFilter(this.reportFilter);
    }, 1400)
  }

  clearDropdownSearch() {
    this.searchDropdown = '';
    this.dropdownItems = [];
    delete this.reportFilter['requestedBy']
    this.dashboardService.setReportFilter(this.reportFilter);
  }
  initStatusFilter() {
    this.dismissialStatueses = [];
    if (this.statusType) {
      switch (this.statusType) {
        case 'with_staff':
          this.dismissialStatueses = [
            // reports-controlbar.stasus.all-students
            { name: 'reports-controlbar.stasus.all-with-staff', value: { status: 'with_staff' } },
            { name: 'reports-controlbar.stasus.with-teacher', value: { status: 'with_teacher', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-supervisor', value: { status: 'with_supervisor', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-security', value: { status: 'with_security', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-teacher-qr', value: { status: 'with_teacher', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-supervisor-qr', value: { status: 'with_supervisor', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-security-qr', value: { status: 'with_security', type: 'qr' } },
          ]
          break;
        case 'all_delivered':
          this.dismissialStatueses = [
            { name: 'reports-controlbar.stasus.all-delivered', value: { status: 'all_delivered' } },
            { name: 'reports-controlbar.stasus.delivered', value: { status: 'delivered', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-parent', value: { status: 'with_parent', type: 'flow' } },
            { name: 'reports-controlbar.stasus.delivered-qr', value: { status: 'delivered', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-parent-qr', value: { status: 'with_parent', type: 'qr' } },
          ]
          break;
        case 'pending':
          this.dismissialStatueses = [
            { name: 'reports-controlbar.stasus.all-getting-ready', value: { status: 'pending' } },
            { name: 'reports-controlbar.stasus.pending', value: { status: 'pending', type: 'flow' } },
            { name: 'reports-controlbar.stasus.pending-qr', value: { status: 'pending', type: 'qr' } },
          ]
          break;
        case 'students-log':
          this.dismissialStatueses = [
            { name: 'reports-controlbar.stasus.all-students', value: { status: '' } },
            { name: 'reports-controlbar.stasus.pending', value: { status: 'pending', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-teacher', value: { status: 'with_teacher', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-supervisor', value: { status: 'with_supervisor', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-security', value: { status: 'with_security', type: 'flow' } },
            { name: 'reports-controlbar.stasus.with-parent', value: { status: 'with_parent', type: 'flow' } },
            { name: 'reports-controlbar.stasus.delivered', value: { status: 'delivered', type: 'flow' } },
            { name: 'reports-controlbar.stasus.pending-qr', value: { status: 'pending', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-teacher-qr', value: { status: 'with_teacher', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-supervisor-qr', value: { status: 'with_supervisor', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-security-qr', value: { status: 'with_security', type: 'qr' } },
            { name: 'reports-controlbar.stasus.with-parent-qr', value: { status: 'with_parent', type: 'qr' } },
            { name: 'reports-controlbar.stasus.delivered-qr', value: { status: 'delivered', type: 'qr' } },
          ]
          break;
        default:
          break;
      }
    }
  }
  searchHandler() {
    const regex = '^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$';
    let foundError = this.searchInput.match(regex);
    if (this.searchInput === '' || foundError !== null) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.reportFilter.search = this.searchInput;
        this.dashboardService.setReportFilter(this.reportFilter);
      }, 1400)
    }
    else {
      this.snackBar.setSnackBarMessage(this.translate.instant('reports-controlbar.special-char'));
      this._snackBar.openFromComponent(SnackBarErrorComponent, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
  }
  searchDropdownHandler() {
    const regex = '^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$';
    let foundError = this.searchDropdown.match(regex);
    if (this.searchDropdown == '' || this.searchDropdown == null) {
      this.clearDropdownSearch();
    }
    if (this.searchDropdown != '' && this.searchDropdown != null) {
      if (this.searchDropdown === '' || foundError !== null) {
        clearTimeout(this.dropdownTimer);
        this.dropdownTimer = setTimeout(() => {
          this.dashboardService.getDropdownDataBySearch(this.searchDropdown).subscribe(res => {
            this.dropdownItems = res;

          })
        }, 1400)
      }
      else {
        this.snackBar.setSnackBarMessage(this.translate.instant('reports-controlbar.special-char'));
        this._snackBar.openFromComponent(SnackBarErrorComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    }
  }

  selectItem(event) {
    this.reportFilter.requestedBy = event.target.id;
    this.searchDropdown = event.target.innerText;
    this.dashboardService.setReportFilter(this.reportFilter)
    this.dropdownItems = [];
  }

  dateChanged(event) {
    this.reportFilter.fromDate = moment(this.rangeDates[0]).format('YYYY-MM-DD');
    this.reportFilter.toDate = moment(this.rangeDates[1]).format('YYYY-MM-DD');

    let temp: any = this.rangeDates;

    this.dashboardService.setRangeDate(temp)

    if (this.rangeDates[1] !== null) {
      this.dashboardService.setReportFilter(this.reportFilter)
    }
  }

  setReportType(reportType) {
    this.reportType = reportType;
    this.dashboardService.setReportType(reportType)
  }

  print() {
    this.hideDateRanges = true;
    this.hideDate = true;
    let cardToPrint = $('#studentAttendanceReport').hasClass('show') ? '#report-card-modal' : '#report-card'
    this._ngZone.runOutsideAngular(() => {
      html2canvas(document.querySelector(cardToPrint), { logging: true, allowTaint: false, useCORS: true }).then(canvas => {
        const imgData = canvas.toDataURL('image/jpeg', 1);
        const documentDefinition = this.getDocumentDefinition(imgData);
        pdfMake.createPdf(documentDefinition).print();
      });
    })
    setTimeout(() => {
      this.hideDateRanges = false;
      this.hideDate = false;
    }, 1000);
  }

  download() {
    this.dashboardService.setDownloadData(true);
  }

  getDocumentDefinition(imgData) {
    return {
      pageSize: 'A4',
      pageOrientation: 'Landscape',
      content: [
        {
          pageSize: 'A4',
          image: imgData,
          margin: [-25, -35, -25, -14],
          fit: [600, 600],
        }
      ]
    }
  }
  attendanceBack() {
    this.router.navigateByUrl('/reports/dashboard');
  }
  exportToExcel(value: string) {
    this.exportExcel.emit(value)
  }

  generateExcelFile(value: boolean) {
    this.globalService.setExportAlert('preparing');
    this.generateExcel.emit(value)
  }

  checkAll(filterBy: string) {
    // user select all grades by default we will select all classes   
    if (filterBy === 'grade') {
      this.selectedGrades = this.allGradesIsChecked == true ? [...this.grades] : [];
      this.showedClasses = this.allGradesIsChecked == true ? JSON.parse(JSON.stringify(this.classes)) : [];
      this.selectedClasses = [];
      if (this.selectedGrades.length > 0) {
        this.selectedGrades.map(selectedGrade => {
          this.filterValues.grades.push(selectedGrade.name)
        })
        this.grades.map(grade => {
          grade['isSelected'] = true;
        })
      }
      else {
        // user deselect all grades so by default deslect all classes
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.selectedGradesCheckBoxes = [];
        this.selectedClassesCheckBoxes = [];
        this.filterValues.grades = [];
        this.filterValues.classes = [];
      }
    }
    // user selected all classes
    else {
      this.selectedClasses = this.allClassesIsChecked == true ? this.showedClasses : [];
      if (this.selectedClasses.length > 0) {
        this.selectedClasses.map(selectedClass => {
          this.filterValues.classes.push(selectedClass.name)
        })
        this.showedClasses.map(showedClass => {
          showedClass['isSelected'] = true;
        })
      }
      else {
        this.filterValues.classes = [];
      }
    }
    this.dashboardService.setFilterValue(this.filterValues);
  }

  filterHandler(filterBy: string, event) {
    // if user filtered by grades
    if (filterBy === 'grade') {


      if (event.checked) {
        this.allClassesIsChecked = this.allClassesIsChecked == true ? false : false;
        this.selectedGrades.push(event.source.value);
        this.selectedGradesCheckBoxes.push(event);
        this.filterValues.grades.push(event.source.value.name);
      }
      else {
        this.selectedGrades = this.selectedGrades.filter(selectedGrade => selectedGrade.id !== event.source.value.id);
        if (this.selectedGrades.length == 0) {
          this.allGradesIsChecked = false;
        }
        this.selectedGradesCheckBoxes = this.selectedGradesCheckBoxes.filter(selectedGradeCb => selectedGradeCb.source.value.id !== event.source.value.id)
        this.selectedClasses = this.selectedClasses.filter(selectedClass => selectedClass.grade_id !== event.source.value.id);
        this.selectedClassesCheckBoxes = this.selectedClassesCheckBoxes.filter(selectedClassCheckBox => selectedClassCheckBox.source.value.grade_id !== event.source.value.id);
        this.filterValues.grades = this.filterValues.grades.filter(grade => grade !== event.source.value.name);
        this.filterValues.classes = [];
        this.selectedClasses.map(selectedClass => {
          this.filterValues.classes.push(selectedClass.name);
        })
      }
      this.updateClasses();
    }
    // if user filtered by class
    if (filterBy === 'class') {
      if (event.checked) {
        this.selectedClasses.push(event.source.value);
        this.selectedClassesCheckBoxes.push(event);
        this.filterValues.classes.push(event.source.value.name);
      }
      else {
        this.selectedClasses = this.selectedClasses.filter(selectedClass => selectedClass.id !== event.source.value.id);
        if (this.selectedClasses.length == 0) {
          // the user unchecked all classes 
          this.allClassesIsChecked = false;
        }
        this.selectedClassesCheckBoxes = this.selectedClassesCheckBoxes.filter(selectedClassCb => selectedClassCb.source.value.id !== event.source.value.id);
        this.filterValues.classes = this.filterValues.classes.filter(oneClass => oneClass !== event.source.value.name);
      }
    }
    this.dashboardService.setFilterValue(this.filterValues);
  }

  updateClasses() {
    // all classes in selected grade to be shown in filter list
    this.showedClasses = [];
    if (this.selectedGrades.length == 0) {
      this.selectedClasses = [];
      this.filterValues.classes = [];
    }
    else {
      this.selectedGrades.map(grade => {
        this.showedClasses.push(...JSON.parse(JSON.stringify(grade.school_classes)));
      })
      for (let i = 0; i < this.selectedClasses.length; i++) {
        if (this.selectedClasses[i].id === this.showedClasses[i].id) {
          this.showedClasses[i]['isSelected'] = true;
        }
      }
    }
  }

  toggleFilter() {
    this.filterStatus = !this.filterStatus;
    this.dashboardService.toggleFilterStatus(this.filterStatus);
  }

  openFilter(event) {
    this.dashboardService.toggleFilterStatus(true);
    event.stopPropagation();
  }
  close(event, tag: string) {
    switch (tag) {
      case "gradeTag":
        this.filteredAppliedFlag = false;
        let temp = this.dashboardService.filterData;
        temp.grades = [];
        temp.classes = [];
        this.dashboardService.setFilterValue(temp);
        this.dashboardService.setClearFilter(true);
        break;
      case "atttendanceTag":
        this.filteredAttendanceAppliedFlag = false;
        let temp2 = this.dashboardService.filterData;
        temp2.attendance = [];

        this.dashboardService.setFilterValue(temp2);
        break;
    }
    this.dashboardService.setClearFilter(true);
    event.stopPropagation();
  }
}